<template>
  <basic-container style="padding-bottom: 50px !important">
    <el-button @click="addForm" type="primary">新增表单</el-button>
    <el-table
      lazy
      :data="tableData"
      style="width: 100%"
      v-loading="tableLoading"
    >
      <el-table-column prop="id" label="id" width=""> </el-table-column>
      <el-table-column prop="formCode" label="表单编码" width="">
      </el-table-column>
      <el-table-column prop="formName" label="表单名" width="">
      </el-table-column>

      <el-table-column fixed="right" label="状态" width="">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status > 0">{{
            "已启用"
          }}</el-tag>
          <el-tag type="danger" v-else>{{ "已停用" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="">
        <template slot-scope="scope">
          <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
          <el-button type="text" @click="handleEdit(scope.row)" size="small"
            >设计表单</el-button
          >
          <el-button type="text" @click="removeFormDesignHandler(scope.row)" size="small"
            >删除</el-button
          >
          <!-- <el-button type="text" @click="handleDetail(scope.row)" size="small"
            >表单数据</el-button
          >
          <el-button type="text" @click="handlePage(scope.row)" size="small"
            >预览表单页面</el-button
          > -->

          <el-button
            type="text"
            icon="el-icon-setting"
            size="small"
            @click.native="
              switchFormButtonHandler(scope.row.id, scope.row.status)
            "
            >{{ scope.row.status > 0 ? "停用" : "启用" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="overflow: hidden">
      <div class="block" style="float: right">
        <!-- <span class="demonstration">完整功能</span> -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </basic-container>
</template>

<script>
import {
  getPublicTableFormDataList,
  getExtendTableFormDataList,
  handleExtendFormSwitchBtnStatus,
  handlePublicFormSwitchBtnStatus,
  removeFormDesign
} from "@/api/form";
import { getFormById } from "@/api/form";
export default {
  data() {
    return {
      tableLoading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      type: "",
      tableid: "",
      pageUrl_:''
    };
  },

  created() {
    this.pageUrl_ = this.$route.query.pageUrl;
    this.deptId = this.$route.query.deptId;
    this.type = this.$route.query.type;
    this.tableid = this.$route.query.tableid;
    this.projectId = this.$route.query.projectId;
    this.getFormDataList(this.type, this.tableid);
  },

  activated(){
    // getFormList(this.currentPage, this.pageSize).then((res) => {
    //   console.log(res.data.data.data);
    //   this.totalData = res.data.data.total;
    //   this.tableData = res.data.data.data;
    // });
    this.pageUrl_ = this.$route.query.pageUrl;
    this.deptId = this.$route.query.deptId;
    this.type = this.$route.query.type;
    this.tableid = this.$route.query.tableid;
    this.getFormDataList(this.type, this.tableid);
  },
  methods: {
    removeFormDesignHandler(row){
      let type = this.$route.query.type;

      let typeCode = '';
      if(type === 'extend'){
        typeCode = 2;
      }else{
        typeCode = 1;
      }
      let formId = row.id
      let self = this;
        this.$confirm("确定删除该表单?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          removeFormDesign(typeCode,formId).then((res)=>{
            console.log(res)
                self.getFormDataList(self.type, self.tableid);
          });
        });
    },
    switchFormButtonHandler(id, status) {
      let statu = 0;
      if (parseInt(status) == 1) {
        statu = 0;
      } else {
        statu = 1;
      }
      let type = this.$route.query.type;
      let deptId = this.$route.query.deptId;
      let projectId = this.$route.query.projectId;
      
      if (type === "extend") {
        handleExtendFormSwitchBtnStatus(
          id,
          statu,
          this.pageUrl_,
          deptId,
          projectId
        ).then((res) => {
          if (res.data.success) {
            this.$message.success("操作成功!");
            this.getFormDataList(this.type, this.tableid);
          }
        });
      } else {
        handlePublicFormSwitchBtnStatus(id, statu, this.pageUrl_,
          projectId).then(
          (res) => {
            if (res.data.success) {
              this.$message.success("操作成功!");
              this.getFormDataList(this.type, this.tableid);
            }
          }
        );
      }
    },
    getFormDataList(type, tableid) {
      if (type === "public") {
        getPublicTableFormDataList(tableid).then((res) => {
          console.log(res.data.data.records);
          this.totalData = res.data.data.total;
          this.tableData = res.data.data.records;
          this.tableLoading = false;
        });
      } else {
        getExtendTableFormDataList(tableid).then((res) => {
          console.log(res.data.data.records);
          this.totalData = res.data.data.total;
          this.tableData = res.data.data.records;
          this.tableLoading = false;
        });
      }
    },
    getTypeValue(type) {
      if (type === "public") {
        return 1;
      } else {
        return 2;
      }
    },
    addForm() {
      if (
        document.querySelector(
          'div[id*="tab-/form-generator/form-generator"]>span[class="el-icon-close"]'
        )
      ) {
        document
          .querySelector(
            'div[id*="tab-/form-generator/form-generator"]>span[class="el-icon-close"]'
          )
          .click();
      }
      this.$router.push({
        path: `/form-generator?type=${this.getTypeValue(this.type)}&deptId=${
          this.deptId
        }&tableid=${this.tableid}&pageUrl=${this.pageUrl_}&projectId=${this.projectId}`,
        // &redirect_url=${encodeURI(location.hash.substring(1))}
      });
    },
    handleEdit(row) {
      console.log(row.id);
      if (
        document.querySelector(
          'div[id*="tab-/form-generator/form-generator"]>span[class="el-icon-close"]'
        )
      ) {
        document
          .querySelector(
            'div[id*="tab-/form-generator/form-generator"]>span[class="el-icon-close"]'
          )
          .click();
      }
      this.$router.push({
        path: `/form-generator?id=${row.id}&type=${this.getTypeValue(
          this.type
        )}&deptId=${this.deptId}&tableid=${this.tableid}&formCode=${row.formCode}&formName=${row.formName}&pageUrl=${this.pageUrl_}&projectId=${this.projectId}`,
      // &redirect_url=${encodeURI(location.hash.substring(1))}
      });
      // this.centerDialogVisible = true;
      // localStorage.removeItem('avue-form-history');
      // getFormById(row.id).then((res)=>{
      //     console.log(res.data);
      //     setTimeout(()=>{

      //         self.options = JSON.parse(res.data.detail);
      //     },0)
      // });
    },
    handleSizeChange(val) {
      console.log("handleSizeChange");
      this.pageSize = val;

      this.getFormDataList(this.type, this.tableid);
    },
    handleCurrentChange(val) {
      console.log("handleCurrentChange");
      this.currentPage = val;

      this.getFormDataList(this.type, this.tableid);
    },
    handleDetail(row) {
      console.log(row.id);
      if (
        document.querySelector(
          'div[id*="tab-/form-data/form-data"]>span[class="el-icon-close"]'
        )
      ) {
        document
          .querySelector(
            'div[id*="tab-/form-data/form-data"]>span[class="el-icon-close"]'
          )
          .click();
      }
      this.$router.push({ path: `/form-data/form-data?id=${row.id}` });
    },
    handlePage(row) {
      console.log(row.id);
      if (
        document.querySelector(
          'div[id*="tab-/form-detail/form-detail"]>span[class="el-icon-close"]'
        )
      ) {
        document
          .querySelector(
            'div[id*="tab-/form-detail/form-detail"]>span[class="el-icon-close"]'
          )
          .click();
      }
      this.$router.push({ path: `/form-detail/form-detail?id=${row.id}` });
    },
  },
};
</script>
